<template>
  <v-container>
  <v-label>バーコードシート</v-label>
<!--
  <barcode v-bind:value="barcodeValue" :options="{ format: 'pharmacode' }">
    Show this if the rendering fails.
  </barcode>
-->

<v-row>
  <v-col xl="1" >CODE128<br/>（UUID）</v-col>
  <v-col xl="3">
    <barcode v-bind:value="barcodeValue" format='CODE128'  height=80 width=1>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >{{barcodeValue}}</v-col>
</v-row>


<v-row>
  <v-col xl="1" >CODE128<br/>（採用予定）</v-col>
  <v-col xl="3">
<!--    <barcode value="abcd1234" lineColor='#ff7069' format='CODE128'>Show this if the rendering fails.</barcode> -->
    <barcode value="ad044e9b-fcf6-44c2-b6f6-5a1282838c86" format='CODE128' height=80 width=1>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >ad044e9b-fcf6-44c2-b6f6-5a1282838c86</v-col>
</v-row>

<v-row>
  <v-col xl="1" >CODE128<br/>（採用予定 長いバーコード）</v-col>
  <v-col xl="3">
<!--    <barcode value="abcd1234" lineColor='#ff7069' format='CODE128'>Show this if the rendering fails.</barcode> -->
    <barcode value="1234567890-abcdefg" format='CODE128' height=80>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >1234567890-abcdefg</v-col>
</v-row>


<v-row>
  <v-col xl="1" >CODE128<br/>（採用予定大）</v-col>
  <v-col xl="3">
    <barcode value="1234-abc" format='CODE128'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >1234-abc</v-col>
</v-row>
<v-row>
  <v-col xl="1" >CODE128<br/>（採用予定小）</v-col>
  <v-col xl="3">
    <barcode value="1234-abc" format='CODE128' height=60>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >1234-abc</v-col>
</v-row>



<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>

  <v-label>その他のバーコード規格</v-label>

<v-row>
  <v-col xl="1" >CODE128A</v-col>
  <v-col xl="3">
    <barcode value="EXAMPLE\n1234" format='CODE128'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >EXAMPLE\n1234</v-col>
</v-row>

<v-row>
  <v-col xl="1" >CODE128B</v-col>
  <v-col xl="3">
    <barcode value="Example1234" format='CODE128B'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >Example1234</v-col>
</v-row>

<v-row>
  <v-col xl="1" >CODE128C</v-col>
  <v-col xl="3">
    <barcode value="12345678" format='CODE128C'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >12345678</v-col>
</v-row>

<v-row>
  <v-col xl="1" >CODE39</v-col>
  <v-col xl="3">
    <barcode value="1234-abc" format='CODE39'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >1234-abc</v-col>
</v-row>
<v-row>
  <v-col xl="1" >EAN13</v-col>
  <v-col xl="3">
    <barcode value="5901234123457" format='EAN13'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1">5901234123457</v-col>
</v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>

<v-row>
  <v-col xl="1" >EAN8</v-col>
  <v-col xl="3">
   <barcode value="96385074" format='EAN8'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >96385074</v-col>
</v-row>
<v-row>
  <v-col xl="1" >EAN5</v-col>
  <v-col xl="3">
   <barcode value="12345" format='EAN5'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >12345</v-col>
</v-row>
<v-row>
  <v-col xl="1" >EAN2</v-col>
  <v-col xl="3">
   <barcode value="12" format='EAN2'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >53</v-col>
</v-row>
<v-row>
  <v-col xl="1" >UPC</v-col>
  <v-col xl="3">
   <barcode value="123456789999" format='UPC'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >123456789999</v-col>
</v-row>

<v-row>
  <v-col xl="1" >ITF14</v-col>
  <v-col xl="3">
   <barcode value="12345678901231" format='ITF14'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >12345678901231</v-col>
</v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row><v-col></v-col></v-row>
<v-row>
  <v-col xl="1" >MSI</v-col>
  <v-col xl="3">
   <barcode value="1234567890" format='MSI'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >1234567890</v-col>
</v-row>
<v-row>
  <v-col xl="1" >MSI10</v-col>
  <v-col xl="3">
   <barcode value="1234567890" format='MSI10'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >1234567890</v-col>
</v-row>
<v-row>
  <v-col xl="1" >pharmacode</v-col>
  <v-col xl="3">
   <barcode value="1234-abcdefg" format='pharmacode'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >1234-abcdefg</v-col>
</v-row>
<v-row>
  <v-col xl="1" >codabar</v-col>
  <v-col xl="3">
   <barcode value="1234567890" format='codabar'>Show this if the rendering fails.</barcode>
  </v-col>
  <v-col xl="1" >1234567890</v-col>
</v-row>

  </v-container>
</template>

<script>
import VueBarcode from 'vue-barcode';
import generateUuid  from '../utils/generateUuid.js'

export default {
  mixins:[generateUuid ],
  components: {
    'barcode': VueBarcode
  },
  data: () => ({
    barcodeValue: '1234567890',
    options: {
        lineColor: '#ff7069',
        fontSize: 32,
        font: 'Courier',
        width: 3,
        height: 60,
        marginBottom: 60,
        format: 'MSI',
        background: '#ccffff'
    },
  }),
  mounted: async function () {
    let uuid = this.generateUuid("xxxx-xxxx-4xxx-yxxx-yxxx")
    console.log("■■generateUuid", uuid)

    let uuid2 = this.getUniqueStr(100000000)
    console.log("■■getUniqueStr", uuid2)

    this.barcodeValue = uuid

  },
  methods: {


      getUniqueStr:  function (myStrong) {
        var strong = 1000;
        if (myStrong) strong = myStrong;
        return new Date().getTime().toString(16)  + Math.floor(strong*Math.random()).toString(16)
        }

  },
}
</script>